import React, { useEffect } from 'react';
import { ActionCreators as UndoActionCreators } from 'redux-undo';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import PropTypes from 'prop-types';

import Tooltip from '../../../componentLibrary/Tooltip';
import Button from '../../../componentLibrary/Button';
import { APPLICATION_MODES } from '../../../constants/itemTypes/itemTypes';
import * as selectedElementsActions from '../../../actions/selectedElements';
import * as selectedBlocksActions from '../../../actions/selectedBlocks';
import getArrayIndices from '../../../reducers/common/getStateArrayIndices';
import * as Styled from './styles';

const UndoRedo = (props) => {
    const {
        canUndo, canRedo, onUndo, onRedo, applicationMode, canvasBlocks, selectedElements, dispatch, changeLog, multipleConnections,
    } = props;

    useEffect(() => {
        if (changeLog === 'pressed undo button.') {
            Object.entries(selectedElements).forEach(([elementIndex, element]) => {
                const { blockIndex, columnIdx } = element;
                const { blockArrIdx, columnArrIdx, elmArrIdx } = getArrayIndices(canvasBlocks, blockIndex, columnIdx, elementIndex[0]);
                if (blockArrIdx === -1) {
                    dispatch(selectedElementsActions.removeSelectedElement(elementIndex));
                    dispatch(selectedBlocksActions.removeSelectedBlock({ index: blockIndex }));
                    return;
                }

                if (columnArrIdx === -1 || elmArrIdx === -1) {
                    dispatch(selectedElementsActions.removeSelectedElement(elementIndex));
                }
            });
        }
    }, [changeLog]);

    return (
        <Styled.UndoRedo>
            {applicationMode === APPLICATION_MODES.EDITOR && (
                <>
                    <Styled.UndoIconDiv>
                        <Tooltip
                            text="Undo is unavailable while other users are connected"
                            id="undo-tooltip"
                            disableTooltip={!multipleConnections}
                        >
                            <Button
                                type="simple"
                                width={30}
                                label="Undo"
                                icon="undo-alt"
                                iconSize={15}
                                marginBottom={0}
                                padding="5px 0px 0px 0px"
                                disabled={!canUndo || multipleConnections}
                                color={!canUndo ? 'lightgray' : '#535454'}
                                onClick={onUndo}
                            />
                        </Tooltip>
                    </Styled.UndoIconDiv>
                    <Styled.VerticalDivider />
                    <Styled.RedoIconDiv>
                        <Tooltip
                            text="Redo is unavailable while other users are connected"
                            id="redo-tooltip"
                            disableTooltip={!multipleConnections}
                        >
                            <Button
                                type="simple"
                                width={30}
                                label="Redo"
                                icon="redo-alt"
                                iconSize={15}
                                marginBottom={0}
                                padding="5px 0px 0px 0px"
                                disabled={!canRedo || multipleConnections}
                                color={!canRedo ? 'lightgray' : '#535454'}
                                onClick={onRedo}
                            />
                        </Tooltip>
                    </Styled.RedoIconDiv>
                </>
            )}
        </Styled.UndoRedo>
    );
};

const mapStateToProps = (state) => ({
    canUndo: state.canvasBlocks.past.length > 0,
    canRedo: state.canvasBlocks.future.length > 0,
    multipleConnections: _get(state, 'session.collaboration.connectedClients', [])
        .filter((user) => user.socketId !== _get(state, 'session.collaboration.currentUserSocketId', ''))
        .length > 0,
    selectedElements: state.selectedElements.local,
    canvasBlocks: state.canvasBlocks.present,
    changeLog: state.changeLog,
});

const mapDispatchToProps = (dispatch) => ({
    onUndo: () => dispatch(UndoActionCreators.undo()),
    onRedo: () => dispatch(UndoActionCreators.redo()),
    dispatch,
});

UndoRedo.propTypes = {
    dispatch: PropTypes.func.isRequired,
    canUndo: PropTypes.bool.isRequired,
    canRedo: PropTypes.bool.isRequired,
    onUndo: PropTypes.func.isRequired,
    onRedo: PropTypes.func.isRequired,
    applicationMode: PropTypes.string.isRequired,
    multipleConnections: PropTypes.bool.isRequired,
    selectedElements: PropTypes.object.isRequired,
    canvasBlocks: PropTypes.array.isRequired,
    changeLog: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UndoRedo);
